import React, { useState } from 'react';
import {  Badge,Card, Button, Collapse, ListGroup, Alert } from "react-bootstrap";
import { MessageTranslation } from '../../api/types/messages';

import { CKEditor } from "@ckeditor/ckeditor5-react";
    
//import Editor from 'ckeditor5-custom-build';

import { Base64 } from 'js-base64';
import { useAvailableVariables, VariableDescriptor } from '../../hooks';
import { MessageCKEditor } from '../../ckeditor/editor';

interface MessageTranslationEditorProps {
    trans: MessageTranslation;
    onSubmit: (m:MessageTranslation)=>void;
    onCancel: ()=>void;
 }

export const MessageTranslationEditor: React.FC<MessageTranslationEditorProps> = (props) => {
 
    const [subject, setSubject] = useState(props.trans.subject);
    
    const [content, setContent] = useState( () => {
        if(props.trans.templateDef) {
            return Base64.decode(props.trans.templateDef);
        }
        return '';
    });
    
    console.log(MessageCKEditor.defaultConfig);
    console.log(MessageCKEditor.builtinPlugins);
    console.log(MessageCKEditor.name);
    const [showVariables, setShowVariables] = useState(false);


    const availableVariables = useAvailableVariables();

    const variableDescription = (v: VariableDescriptor) => {

        const syntax = v.kind === 'local' ? '{=' + v.name + '=}' : '{{ ' + v.name +  ' }}'

        return <React.Fragment>
            <Badge bg="warning">{v.kind}</Badge>
            <var className='mx-1 text-danger'>{syntax}</var>
            <span className="text-muted">{v.description}</span>
        </React.Fragment>
    }


    const handleSubmit =() => {
        props.onSubmit({
            lang: props.trans.lang,
            templateDef: Base64.encode(content),
            subject: subject
        });
    };

    const handleCancel =() => {
        props.onCancel() 
    };
  
    return <Card className='m-1 p-2'>
        <Card.Title>Message translation for <Badge bg="secondary">{props.trans.lang}</Badge></Card.Title>
        <Card.Body>
        <div>
        Message subject  : <input type="text" defaultValue={subject} onChange={(ev)=> setSubject(ev.currentTarget.value) } className="w-100 mb-1"/>
        </div>
        <div className='my-1'>
        <CKEditor editor={ MessageCKEditor }
            data = {content}
            config = {{
               
            }}
            onChange={ ( event, editor ) => {
                console.log('editor', editor);
                const data = editor.getData();
                setContent(data);
             } 
            }
        />
        </div>
        <Button onClick={handleSubmit} size="sm" className='me-1'>Save this translation</Button>
        <Button onClick={handleCancel} variant="danger" size="sm">Cancel</Button>

        <Button className='ms-1' size="sm" onClick={() => setShowVariables(!showVariables)} aria-controls="variable-collapse-text"aria-expanded={showVariables}>
        Show variables
         </Button>

        <Collapse in={showVariables}>
            <div className='mt-1'>
            <h6>Available Variables</h6>
            <Alert variant='info'>
                Template variables are available in 2 forms : 
                <ul>   
                    <li>local : using <b>{"{"}=variable={"}"}</b> syntax, its rendered by the admin site before the email template is installed on the platform, it will render the same content for all participants/messages sent. It's used for platform specific content. Once installed these variables are not visible anymore, they have been replaced by their value before the installation on the platform.</li>
                    <li>server : using <b>{"{{ "}variable{" }}"}</b> syntax, it's rendered on the server on the message creation and can contain content specific to each user (used for message personalization). These variables still appear on the messages installed on the platform </li>
                </ul>
            </Alert>
            <ListGroup >
                { 
                    availableVariables.map( (v, i) => {
                        return <ListGroup.Item key={i}>
                            { variableDescription(v) }
                        </ListGroup.Item>;
                    })
                }
            </ListGroup>
            </div>
        </Collapse>
        </Card.Body>
    </Card>;
}